import React, { useState } from 'react';

const Team = () => {
  const [imageErrors, setImageErrors] = useState({});

  const handleImageError = (name) => {
    setImageErrors(prev => ({ ...prev, [name]: true }));
  };

  // Helper function to clean phone numbers for tel: links
  const cleanPhoneNumber = (phone) => {
    return phone.replace(/[^0-9+]/g, '');
  };

  const executives = [
    {
      name: "Sanjay Singh Sohal",
      position: "Group Chairman & CEO - Mauritius & RSA Head Office",
      email: "sanjay@oxycomgroup.com",
      phone: "+263 78 656 6586",
      image: "/images/team/sanjay.png",
      description: "Leading Oxycom's global strategy and expansion with over 15 years of experience in international commodity trading.",
      initials: "SS"
    },
    {
      name: "Tex Werrett",
      position: "Zimbabwe Executive Director",
      email: "tex@oxycomgroup.com",
      phone: "+263 77 388 7986",
      image: "/images/team/tex.jpg",
      description: "Driving Oxycom's operations with extensive expertise in regional commodity markets.",
      initials: "TW"
    },
    
    {
      name: "Zandile Matiwaza",
      position: "Zimbabwe Country Director",
      email: "zandile@oxycomgroup.com",
      phone: "+44 7471 220687",
      image: "/images/team/zandile.jpg",
      description: "Leading Zimbabwe operations with deep knowledge of commodity markets and supply chain optimization.",
      initials: "ZM"
    },
    {
      name: "Shaffique Maru",
      position: "USA Managing Director",
      email: "shaffique@oxycomgroup.com",
      phone: "+1 (718) 687-8732",
      image: "/images/team/shaffique.jpg",
      description: "Leading USA operations with deep knowledge of commodity markets and supply chain optimization.",
      initials: "SM"
    },
    {
      name: "Jaimin Patel",
      position: "Zambia Managing Director",
      email: "jaimin@oxycomgroup.com",
      image: "/images/team/jaimin.jpg",
      phone: "+260-779-116-666",
      description: "Leading Zambia operations with deep knowledge of commodity markets and supply chain optimization.",
      initials: "JP"
    }
  ];

  const salesTeam = [
  {
    name: "Elsa Macumbe",
    position: "Beira Branch Manager",
    email: "elsa@oxycomgroup.com",
    phone: "+258 86 085 3002",
    image: "/images/team/elsa.jpg",
    description: "Leading the Beira branch with expertise in commodity trading and client relationship management.",
    initials: "EM"
  },
  {
    name: "Sundeep Sohal",
    position: "Lilongwe Branch Manager",
    email: "sundeep@oxycomgroup.com",
    phone: "+265 995 00 95 69",
    image: "/images/team/sundeep.jpg",
    description: "Managing sales operations across Malawi markets with focus on business development and market expansion.",
    initials: "SS"
  },
  {
    name: "Zander Davel",
    position: "National Sales Manager - South Africa",
    email: "zander@oxycomgroup.com",
    phone: "+27 88 888 8888.",
    image: "/images/team/zander.jpg",
    description: "Overseeing national sales strategy and operations in South Africa, driving revenue growth and market penetration.",
    initials: "ZD"
  },
  {
    name: "Phillip Tembo",
    position: "National Sales Manager - Zambia",
    email: "phillip@oxycomgroup.com",
    phone: "+260 97 123 4567",
    image: "/images/team/phillip.jpg",
    description: "Leading sales initiatives across Zambia, developing strategic partnerships and expanding market presence.",
    initials: "PT"
  },
  {
    name: "Christian Jacobs",
    position: "Sales Executive - South Africa",
    email: "christian@oxycomgroup.com",
    phone: "+27 79 765 4321",
    image: "/images/team/christian.jpg",
    description: "Executing sales strategies and building client relationships to drive business growth in South Africa.",
    initials: "CJ"
  },
  {
    name: "Ashley Randen",
    position: "Senior Sales and Marketing Executive - Zimbabwe",
    email: "ashley@oxycomgroup.com",
    phone: "+263 77 654 3210",
    image: "/images/team/ashley.jpg",
    description: "Developing integrated sales and marketing strategies to expand market share and brand presence in Zimbabwe.",
    initials: "AR"
  },
  {
    name: "Marcus Mng'ong'o",
    position: "National Sales and Marketing Manager - Tanzania",
    email: "marcus@oxycomgroup.com",
    phone: "+255 712 345 678",
    image: "/images/team/marcus.jpg",
    description: "Leading national sales and marketing teams in Tanzania, driving revenue growth and strategic market development.",
    initials: "MM"
  }
];

  const TeamCard = ({ member }) => {
    const hasError = imageErrors[member.name];
    
    return (
      <div className="team-card-modern">
        <div 
          className={`team-image ${hasError ? 'image-error' : ''}`}
          data-initials={member.initials}
        >
          <img 
            src={member.image} 
            alt={member.name}
            className="team-photo"
            onError={() => handleImageError(member.name)}
          />
          <div className="team-overlay">
            <div className="contact-details">
              <strong>Email:</strong>
              <a href={`mailto:${member.email}`} className="contact-info contact-link">
                {member.email}
              </a>
              <strong>Phone:</strong>
              <a href={`tel:${cleanPhoneNumber(member.phone)}`} className="contact-info contact-link">
                {member.phone}
              </a>
            </div>
          </div>
        </div>
        <div className="team-content">
          <h3>{member.name}</h3>
          <p className="team-position">{member.position}</p>
          <p className="team-description">{member.description}</p>
          
          {/* Desktop contact info - always visible on desktop */}
          <div className="desktop-contact">
            <p>
              <strong>Email:</strong>{' '}
              <a href={`mailto:${member.email}`} className="contact-link">
                {member.email}
              </a>
            </p>
            
          </div>
          
          {/* Mobile contact info - visible on small screens */}
          <div className="mobile-contact">
            <p>
              <strong>Email:</strong>{' '}
              <a href={`mailto:${member.email}`} className="contact-link">
                {member.email}
              </a>
            </p>
            
          </div>
        </div>
      </div>
    );
  };

  return (
    <section id="team" className="team-section">
      {/* Background Pattern Overlay */}
      <div className="background-pattern"></div>
      
      <div className="container">
        {/* Executive Management Section */}
        <div className="team-header">
          <h1>EXECUTIVE MANAGEMENT</h1>
        </div>

        <div className="team-grid">
          {executives.map((executive, index) => (
            <TeamCard key={index} member={executive} />
          ))}
        </div>

        {/* Sales Team Section */}
        <div className="team-header" style={{marginTop: '4rem'}}>
          <h1>SALES TEAM</h1>
        </div>

        <div className="team-grid">
          {salesTeam.map((member, index) => (
            <TeamCard key={index} member={member} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;